import request from '@/utils/request'

// 阅文列表
export function yuewenList(params = {}) {
  return request({
    url: '/yuewen/put_monitor/index',
    method: 'get',
    params
  })
}

// 新增
export function yuewenAdd(data = {}) {
  return request({
    url: '/yuewen/put_monitor/create',
    method: 'post',
    data
  })
}

// 删除
export function yuewenDel(data = {}) {
  return request({
    url: '/yuewen/put_monitor/destroy',
    method: 'post',
    data
  })
}

// 获取阅文业务列表
// 无请求体 返回体coopid
export function getCoops(params = {}) {
  return request({
    url: '/yuewen/put_monitor/get_coops',
    method: 'get',
    params
  })
}

// 获取阅文产品列表
export function getApp(params = {}) {
  return request({
    url: '/yuewen/put_monitor/get_app',
    method: 'get',
    params
  })
}

// 策略开关
export function switchstrategy(data = {}) {
  return request({
    url: '/yuewen/put_monitor/switch_strategy',
    method: 'post',
    data
  })
}

// 配置开关
export function switchconfig(data = {}) {
  return request({
    url: '/yuewen/put_monitor/switch_config',
    method: 'post',
    data
  })
}
// 修改时间（已废弃，使用 setTime）
export function setInterval(data = {}) {
  return request({
    url: '/yuewen/put_monitor/set_interval',
    method: 'post',
    data
  })
}

// 修改开启时间和关闭时间
export function setTime(data = {}) {
  return request({
    url: '/yuewen/put_monitor/set_interval',
    method: 'post',
    data
  })
}
// 获取阅文账号列表
export function getYueWenAccountList(params = {}) {
  return request({
    url: '/yuewen/yw_account/index',
    method: 'get',
    params
  })
}
// 新增阅文账号
export function addYueWenAccount(data = {}) {
  return request({
    url: '/yuewen/yw_account/create',
    method: 'post',
    data
  })
}

// 登录阅文账号
export function loginYueWen(data = {}) {
  return request({
    url: '/yuewen/yw_account/login',
    method: 'post',
    data
  })
}
// 编辑阅文账号
export function yuewenEdit(data = {}) {
  return request({
    url: '/yuewen/yw_account/update',
    method: 'post',
    data
  })
}
// 删除阅文账号
export function yuewendestroy(data = {}) {
  return request({
    url: '/yuewen/yw_account/destroy',
    method: 'post',
    data
  })
}
